import React from "react"
import Translation from "../global/Translation"

/** @type {object} */
export const rejectionCodeMap = {
    '400': <Translation id="400_rejection_code" defaultMessage="Good discontinued" />,
    '401': <Translation id="401_rejection_code" defaultMessage="Bad thickness" />,
    '402': <Translation id="402_rejection_code" defaultMessage="Fissure" />,
    '403': <Translation id="403_rejection_code" defaultMessage="Holes / pores" />,
    '404': <Translation id="404_rejection_code" defaultMessage="Oxide" />,
    '405': <Translation id="405_rejection_code" defaultMessage="Excess resin" />,
    '406': <Translation id="406_rejection_code" defaultMessage="Grated" />,
    '407': <Translation id="407_rejection_code" defaultMessage="Bad shade / stains" />,
    '408': <Translation id="408_rejection_code" defaultMessage="Half board (leftover)" />,
}

/**
 * Get the rejection code of each bundle.
 * @param {object} lot 
 * @param {array} bundlesRejectionCodes 
 * @returns {(string|null)} rejectionCode
 */
export const getBundleRejectionCode = (lot, bundlesRejectionCodes) => {
    let rejectionCode = null
    if (lot && lot.bundleId && bundlesRejectionCodes && bundlesRejectionCodes.length > 0) {
        rejectionCode = bundlesRejectionCodes.filter((bundle) => bundle.bundleId === lot.bundleId)
        return rejectionCode[0].rejectionCode
    }
    return rejectionCode
}

export const calcLotsDimensions = (lots) => {
    if (lots) {
        lots.map(lot => {
            if (lot.lots && lot.lots.length > 0) {
                const size = lot.lots.length

                lot.length = (lot.lots.reduce((val, child) => {
                    return val + parseFloat(child.length)
                }, 0)/size).toFixed(2)

                lot.width =(lot.lots.reduce((val, child) => {
                    return val + parseFloat(child.width)
                }, 0) / size).toFixed(2)

                lot.length_ft = (lot.lots.reduce((val, child) => {
                    return val + parseFloat(child.length_ft)
                }, 0) / size).toFixed(2)

                lot.length_m = (lot.lots.reduce((val, child) => {
                    return val + parseFloat(child.length_m)
                }, 0) / size).toFixed(1)

                lot.width_ft = (lot.lots.reduce((val, child) => {
                    return val + parseFloat(child.width_ft)
                }, 0) / size).toFixed(2)

                lot.width_m = (lot.lots.reduce((val, child) => {
                    return val + parseFloat(child.width_m)
                }, 0) / size).toFixed(1)

                lot.qty = (lot.lots.reduce((val, child) => {
                    return val + parseFloat(child.qty)
                }, 0) / size).toFixed(2)

                lot.qty_ft2 = (lot.lots.reduce((val, child) => {
                    return val + parseFloat(child.qty_ft2)
                }, 0) / size).toFixed(2)

                lot.qty_m2 = (lot.lots.reduce((val, child) => {
                    return val + parseFloat(child.qty_m2)
                }, 0) / size).toFixed(2)

                lot.quarryBlock = lot.lots[0].quarryBlock
                lot.quality = lot.lots[0].quality
                lot.location = lot.lots[0].location
                lot.qualityOutlet = lot.lots[0].qualityOutlet
                lot.shade = lot.lots[0].shade
                lot.lotId = lot.lots[0].lotId
                lot.count = size
            } else if(lot.length_ft && lot.length_ft.toFixed) {
                // lot.length = lot.length.toFixed(2)
                // lot.width = lot.width.toFixed(2)
                lot.length_ft = lot.length_ft.toFixed(2)
                lot.length_m = lot.length_m.toFixed(0)
                lot.width_ft = lot.width_ft.toFixed(2)
                lot.width_m = lot.width_m.toFixed(0)
                // lot.qty = lot.qty.toFixed(2)
                lot.qty_ft2 = lot.qty_ft2.toFixed(2)
                lot.qty_m2 = lot.qty_m2.toFixed(2)
                lot.count = 1
            }

            return lot
        })
    }
}

export const mapCurrentProductLots = (lots, lotsImages, defaultImage=null) => {
    const productLots = []
    const addLot = (lot) => {
        const foundLot = lot.lots && lot.lots.find((lotInfo) => {
            return defaultImage || (lotsImages[lotInfo.lotId] && !!lotsImages[lotInfo.lotId].image)
        });
        const lotImgData = foundLot ? {...lotsImages[foundLot.lotId]} : {...lotsImages[lot.lotId]}
        if (defaultImage && !lotImgData.image) lotImgData.image  = defaultImage
        if (lotImgData && lotImgData.image) {
            lotImgData.bundleId = lot.bundleId
            lotImgData.quarryBlock = lot.quarryBlock
            lotImgData.quality = lot.quality
            lotImgData.qualityOutlet = lot.qualityOutlet
            lotImgData.shade = lot.shade
            lotImgData.location = lot.location
            lotImgData.width_m = lot.width_m
            lotImgData.width_ft = lot.width_ft
            lotImgData.length_m = lot.length_m
            lotImgData.length_ft = lot.length_ft
            lotImgData.qty_m2 = lot.qty_m2
            lotImgData.qty_ft2 = lot.qty_ft2
            lotImgData.count = lot.count
            lotImgData.rejectionCode = lot.rejectionCode
            productLots.push(lotImgData)
        }
    }

    if (lots && lotsImages) {
        lots.forEach(lot => {
            addLot(lot)
        })
    }

    return productLots;
}